import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from './MetaPixel';
const pains = ["pensamientos que no se detienen", "tristeza o vacío emocional", "miedo a estar solo", "dependencia emocional", "inseguridad", "dificultad para tomar decisiones", "falta de dirección", "sensación de estar estancado"];
export function PainPoints() {
  return <section className="py-24 md:py-32 bg-ink-light relative border-t border-white/5" data-id="element-254" data-mp="1xwyb5yre77xf">
      <div className="container mx-auto px-6" data-id="element-255" data-mp="220e68qntd080">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-256" data-mp="21x07rti9tb5u">
          <motion.h2 className="text-3xl md:text-5xl font-serif text-ivory-bright leading-tight mb-8" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-257" data-mp="1o14sryqzsk7q">
            ¿SIENTES QUE SIGUES FUNCIONANDO... <br className="hidden md:block" data-id="element-258" data-mp="3nabm46u0fu7i" />
            <span className="text-gold italic" data-id="element-259" data-mp="1yzn4bl42jagm">PERO POR DENTRO ALGO SE ROMPIÓ?</span>
          </motion.h2>
          
          <motion.div className="text-lg md:text-xl text-muted font-light leading-relaxed space-y-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-260" data-mp="1u12fehu9od7h">
            <p data-id="element-261" data-mp="1g22r5bao20bu">Puedes seguir trabajando. Puedes seguir sonriendo. Puedes seguir hablando con los demás.</p>
            <p className="text-ivory" data-id="element-262" data-mp="1b4ssd51e0cbc">Pero por dentro puedes sentir:</p>
          </motion.div>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-263" data-mp="1p0eg78vvwq26">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-264" data-mp="1k34pzr0o8ada">
            {pains.map((pain, i) => <motion.div key={i} className="bg-ink border border-white/5 p-4 rounded-xl flex items-center gap-3" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} data-id="element-265" data-mp="30gmgf3nufpao" data-mpi={i}>
                <div className="w-1.5 h-1.5 rounded-full bg-gold shrink-0" data-id="element-266" data-mp="22638484ry763"></div>
                <span className="text-ivory/90 font-light" data-id="element-267" data-mp="274xxxu15svzp">{pain}</span>
              </motion.div>)}
          </div>

          <motion.div className="text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} data-id="element-268" data-mp="1af71hp9b4yr9">
            <p className="text-xl text-ivory-bright font-serif italic mb-10" data-id="element-269" data-mp="1jd91q2l7vndh">
              Y cuanto más tiempo intentas resolverlo solo, más energía puede consumir.
            </p>
            
            <a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366] text-white hover:bg-[#1DA851] transition-all duration-300 font-medium tracking-wide shadow-lg shadow-[#25D366]/20 rounded-xl" data-id="element-270" data-mp="qollwmj8lq7b">
              <MessageCircle className="w-5 h-5" data-id="element-271" data-mp="e9x1sa80sbq2" />
              QUIERO RECUPERAR MI VIDA
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}